module.exports = __webpack_public_path__ + "static/media/texture-wood.a415d062.jpg";